import React, { FC } from 'react'

import { IconUnlimitedProps } from './IconUnlimited.types'
import * as Styled from './styles/IconUnlimited.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUnlimited: FC<IconUnlimitedProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUnlimitedProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconUnlimitedProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M117.41 42c-20.78 0-36.94 28-37.62 29.22v.09C78.53 68.73 65.38 42 42.61 42 22.56 42 8 58 8 80s14.56 38 34.61 38c22.15 0 35.17-24.63 37.22-28.82C82 93 96.67 118 117.41 118c20 0 34.59-16 34.59-38s-14.55-38-34.59-38zM72.89 85.17v.1c-.17.24-11.73 24.73-30.28 24.73C26.94 110 16 97.66 16 80s10.94-30 26.61-30c18.27 0 29.82 24.56 29.93 24.81l2.76 5.46zM117.41 110c-17.17 0-30.63-24.78-30.72-25l-2.44-4.81 2.55-5.15C90.86 68 104.09 50 117.41 50 133.07 50 144 62.34 144 80s-10.93 30-26.59 30z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconUnlimited
